import { render, staticRenderFns } from "./DbTooltip.vue?vue&type=template&id=af1db64e&scoped=true&"
import script from "./DbTooltip.vue?vue&type=script&lang=ts&"
export * from "./DbTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./DbTooltip.vue?vue&type=style&index=0&id=af1db64e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1db64e",
  null
  
)

export default component.exports